import PasswordInputComponent from "./password_input_component";
import PasswordRepetitionComponent from "./password_repetition_component";
import { PasswordConfig } from "./password_config";

export class PasswordComponent {
    private readonly passwordInputComponent: PasswordInputComponent;
    private readonly passwordRepetitionComponent: PasswordRepetitionComponent;

    constructor(document: Document, config: PasswordConfig, validateImmediately: boolean) {
        this.passwordInputComponent = new PasswordInputComponent(document, config.blockListInputSelectors);
        this.passwordRepetitionComponent = new PasswordRepetitionComponent(document, validateImmediately);
        this.passwordRepetitionComponent.registerEventListeners();
    }
}
